import { Breadcrumb, Button, Card } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as TitleIcon } from "../../../assests/images/transfer.svg";
import { useNavigate } from "react-router";
import { ReactComponent as HomeIcon } from "../../../assests/images/home-line.svg";

export default function PendingBeneUpload() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/pending-authorization")}>
              {t("navigation.approval", {
                defaultValue: "Approval",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {" "}
              {t("navigation.bene_file_upload", {
                defaultValue: "Beneficiary File Upload",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {" "}
              {t("navigation.bene_file_upload", {
                defaultValue: "Beneficiary File Upload",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <Card className="application-card h-50">
        {t("pages.pendingApprovals.common_pendingApprovals.coming_soon", {
          defaultValue: "Coming Soon ...",
        })}
      </Card>
    </>
  );
}
